/* Adam Frisör Motion v2 */
(function(){
'use strict';
var reduceMotion=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
if(reduceMotion)return;

var revealObserver=new IntersectionObserver(function(entries){
  entries.forEach(function(entry){
    if(entry.isIntersecting){
      entry.target.classList.add('is-visible');
      revealObserver.unobserve(entry.target);
    }
  });
},{threshold:0.12,rootMargin:'0px 0px -40px 0px'});

function observeReveal(){
  document.querySelectorAll('.adam-reveal:not([data-rr])').forEach(function(el){
    el.setAttribute('data-rr','1');
    revealObserver.observe(el);
  });
}

function applyReveal(){
  document.querySelectorAll('.adam-cards__grid').forEach(function(grid){
    if(grid.dataset.ra)return;
    grid.dataset.ra='1';
    grid.querySelectorAll('.adam-cards__card').forEach(function(card,i){
      card.classList.add('adam-reveal','adam-reveal--scale','adam-reveal--delay-'+Math.min(i+1,5));
    });
  });
  document.querySelectorAll('.adam-services__card').forEach(function(card,i){
    if(card.dataset.ra)return;
    card.dataset.ra='1';
    card.classList.add('adam-reveal','adam-reveal--scale','adam-reveal--delay-'+Math.min(i+1,5));
  });
  document.querySelectorAll('.adam-cards__header,.adam-gallery__header,.adam-cta__header,.adam-contact__header').forEach(function(h){
    if(h.dataset.ra)return;
    h.dataset.ra='1';
    h.classList.add('adam-reveal','adam-reveal--fade');
  });
  document.querySelectorAll('.adam-gallery__media').forEach(function(item,i){
    if(item.dataset.ra)return;
    item.dataset.ra='1';
    item.classList.add('adam-reveal','adam-reveal--delay-'+Math.min(i+1,5));
  });
  document.querySelectorAll('.adam-cta__box').forEach(function(box){
    if(box.dataset.ra)return;
    box.dataset.ra='1';
    box.classList.add('adam-reveal','adam-reveal--scale');
  });
  document.querySelectorAll('.adam-contact__card,.adam-contact__form-wrap').forEach(function(el,i){
    if(el.dataset.ra)return;
    el.dataset.ra='1';
    el.classList.add('adam-reveal','adam-reveal--delay-'+(i+1));
  });
  document.querySelectorAll('.agc__card').forEach(function(el,i){
    if(el.dataset.ra)return;
    el.dataset.ra='1';
    el.classList.add('adam-reveal','adam-reveal--delay-'+Math.min(i+1,5));
  });
  observeReveal();
}

function initSmoothAnchors(){
  document.addEventListener('click',function(e){
    var link=e.target.closest('a[href^="#"]');
    if(!link)return;
    var t=document.querySelector(link.getAttribute('href'));
    if(!t)return;
    e.preventDefault();
    t.scrollIntoView({behavior:'smooth',block:'start'});
  });
}

function initHeroParallax(){
  var heroMedia=document.querySelector('.adam-hero__media');
  if(!heroMedia)return;
  if(window.matchMedia('(max-width:749px)').matches)return;
  var tick=false;
  window.addEventListener('scroll',function(){
    if(tick)return;
    tick=true;
    requestAnimationFrame(function(){
      heroMedia.style.transform='translateY('+(window.scrollY*0.16)+'px)';
      tick=false;
    });
  },{passive:true});
}

function initMagneticButtons(){
  if(window.matchMedia('(max-width:749px)').matches)return;
  document.querySelectorAll('.adam-button--primary').forEach(function(btn){
    btn.addEventListener('mousemove',function(e){
      var r=btn.getBoundingClientRect();
      var x=e.clientX-r.left-r.width/2;
      var y=e.clientY-r.top-r.height/2;
      btn.style.transform='translate('+(x*0.08)+'px,'+(y*0.08)+'px) scale(1.03)';
    });
    btn.addEventListener('mouseleave',function(){
      btn.style.transform='';
    });
  });
}

function init(){
  applyReveal();
  initSmoothAnchors();
  initHeroParallax();
  initMagneticButtons();
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',init);
}else{
  init();
}
})();
